import classNames from "classnames";
import React from "react";
import Loading from "./loading";
import PanelSegmentType from "./PanelSegment/PanelSegment";

interface Props {
  className?: string
  isLoading?: boolean
  contentHeight?: number
  title: string
  subTitle?: string
  articleId?: number
}

const EditViewPanel = (props: React.PropsWithChildren<Props>) => {
  const { className, isLoading, contentHeight } = props;

  const classes = classNames("s1_panel", className);

  return (<div className={classes}>

    <PanelSegmentType>
      <PanelSegmentType.Header size="h2">
        <PanelSegmentType.Title title={props.title} subTitle={props.subTitle} />
        {props.articleId && <PanelSegmentType.SupportQuestionMark articleId={props.articleId} />}
      </PanelSegmentType.Header>
    </PanelSegmentType>

    {(isLoading) && <Loading height={contentHeight} />}
    {(!isLoading) && props.children}
  </div>);
};

export default EditViewPanel;